import React from "react";
import { ShieldPlusIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/links";
export function Hero() {
  return <header className="bg-cream px-4 pb-14 pt-6 sm:pt-10" data-id="element-229" data-mp="cut9pwmq7l4c">
      <div className="mx-auto max-w-5xl text-center" data-id="element-230" data-mp="huxrrr3a8nwo">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-231" data-mp="hvqumgz4et9j">
          <span className="flex items-center gap-2" data-id="element-232" data-mp="mutwxtnpuldt">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-navy text-goldlight" data-id="element-233" data-mp="ms7qjxckabx6">
              <ShieldPlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-234" data-mp="qt9jjwfvxrqp" />
            </span>
            <span className="font-serif text-lg font-bold text-navy" data-id="element-235" data-mp="vof9r7gblskl">Mastopexy Blueprint™</span>
          </span>
          <span className="rounded-full border border-navy/15 bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-navy" data-id="element-236" data-mp="15kiduiuqg1a6">
            For plastic surgeons
          </span>
        </div>

        <h1 className="text-balance mx-auto mt-6 max-w-4xl font-serif text-[34px] font-extrabold leading-[1.08] text-ink sm:text-6xl" data-id="element-237" data-mp="9nt0q07lunif">
          Review the Complete Mastopexy Procedure Sequence in{" "}
          <em className="text-gold" data-id="element-238" data-mp="3vur8otv5hkyq">15 Minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-ink/75 sm:text-xl" data-id="element-239" data-mp="3vvaqmaksw9cr">
          A structured professional training system designed to help plastic surgeons organize their understanding of
          mastopexy — from patient evaluation and planning through the operative sequence, technical considerations and
          postoperative review.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-[17px] leading-relaxed text-ink/75 sm:text-xl" data-id="element-240" data-mp="in690pjzt61k">
          Includes <strong className="text-ink" data-id="element-241" data-mp="eme05xf1935t">6 premium volumes</strong>,{" "}
          <strong className="text-ink" data-id="element-242" data-mp="1b51t2emmhv4z">5 professional bonuses</strong>,{" "}
          <strong className="text-ink" data-id="element-243" data-mp="16ebov4pxnybv">30+ surgical planning tools</strong>, checklists and educational case exercises.
        </p>

        <div className="-mx-4 mt-6 sm:mx-auto sm:max-w-3xl" data-id="element-244" data-mp="30myrem7ibbi4">
          <img src={images.mockup} alt="Mastopexy Surgical Blueprint: 6 volumes, 5 bonuses, planning map, checklists and review cards" className="w-full mix-blend-multiply" data-id="element-245" data-mp="35l0hvs79id3m" />
        </div>

        <p className="mt-2 font-serif text-lg font-bold text-navy sm:text-xl" data-id="element-246" data-mp="2vu5n1zfya56k">
          The 6 volumes + 5 bonuses inside Mastopexy Surgical Blueprint™
        </p>

        <div className="mt-6" data-id="element-247" data-mp="2mu948eg8s0jf">
          <CTAButton id="first-cta" label="I want the Mastopexy Blueprint™" note="Instant digital access · One-time payment of $27 USD · Lifetime access · 7-day guarantee" data-id="element-248" data-mp="2mvk5o7m7sw7d" />
        </div>

        <Countdown data-id="element-249" data-mp="2cwl5ldfim8vz" />
      </div>
    </header>;
}